import { cn } from '@divlab/divanui';

import styles from './WorkTimeNotification.module.css';

import type { FC, HTMLAttributes } from 'react';

interface WorkTimeNotificationProps extends HTMLAttributes<HTMLDivElement> {
  data: string[];
}

const WorkTimeNotification: FC<WorkTimeNotificationProps> = (props) => {
  const { data, className, ...restProps } = props;
  const title = data[0];
  const dates = data.slice(1);

  return (
    <div {...restProps} className={cn(styles.container, className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.schedule}>
        {dates.map((date) => (
          <div key={date} dangerouslySetInnerHTML={{ __html: date }} />
        ))}
      </div>
    </div>
  );
};

export default WorkTimeNotification;
